export var convertStatsReport = function (report) {
    if (!report) {
        return null;
    }
    var statsObject = {};
    report.forEach(function (stat) {
        statsObject[stat.id] = stat;
    });
    if (Object.keys(statsObject).length > 0)
        return statsObject;
    return null;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid3J0Y1V0aWxzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vbGliL3V0aWxzL3dydGNVdGlscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQUMsSUFBTSxrQkFBa0IsR0FBRyxVQUFDLE1BQXlDO0lBQzFFLElBQUksQ0FBQyxNQUFNLEVBQUUsQ0FBQztRQUNaLE9BQU8sSUFBSSxDQUFDO0lBQ2QsQ0FBQztJQUVELElBQU0sV0FBVyxHQUE2QixFQUFFLENBQUM7SUFFakQsTUFBTSxDQUFDLE9BQU8sQ0FBQyxVQUFDLElBQUk7UUFDbEIsV0FBVyxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsR0FBRyxJQUFJLENBQUM7SUFDOUIsQ0FBQyxDQUFDLENBQUM7SUFFSCxJQUFJLE1BQU0sQ0FBQyxJQUFJLENBQUMsV0FBVyxDQUFDLENBQUMsTUFBTSxHQUFHLENBQUM7UUFBRSxPQUFPLFdBQVcsQ0FBQztJQUU1RCxPQUFPLElBQUksQ0FBQztBQUNkLENBQUMsQ0FBQyJ9